import TextArea from "./textarea";

export default class Form {

  protected readonly form: HTMLFormElement;
  protected readonly inputs: NodeListOf<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>;
  protected readonly textareas: TextArea[] = [];
  protected readonly changeHandler: EventListener;

  constructor(form: HTMLFormElement)
  {
    this.form = form;
    this.inputs = this.form.querySelectorAll('input, select, textarea');
    this.changeHandler = this.handleChangeEvent.bind(this);
  }

  public enable(): void
  {
    this.inputs.forEach((input) => {
      this.checkEmptiness(input);
      if(input instanceof HTMLTextAreaElement) {
        this.textareas.push(new TextArea(input));
      }
    })

    // this.form.addEventListener('change', this.changeHandler, false);
  }

  public destroy(): void
  {
    // this.form.removeEventListener('change', this.changeHandler);
  }

  protected handleChangeEvent(event: Event): void
  {
    if(
      event.target instanceof HTMLInputElement
      || event.target instanceof HTMLTextAreaElement
      || event.target instanceof HTMLSelectElement
    )
    {
      if(event.target.classList.contains('fake-radio')) {
        const siblings = event.target.closest('.option-list')?.querySelectorAll('input[type="checkbox"]') as NodeListOf<HTMLInputElement>;
        siblings.forEach((input) => {
          if(input != event.target) {
            input.checked = false;
          }
        })
      }
      this.checkValidity(event.target);
    }
  }

  private checkEmptiness(element: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement): Boolean
  {
    let isEmpty = element.value == "";

    element.classList.toggle('empty', isEmpty);
    element.classList.toggle('not-empty', !isEmpty);

    return isEmpty;
  }

  private checkValidity(element: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null): Boolean
  {
    let isValid = false;

    if(element) {

      isValid = element.checkValidity()

      element.classList.toggle('invalid', !isValid);
      element.classList.toggle('valid', isValid);

      if(element.type == 'radio' || element.type == 'checkbox') {

        const fieldset = element.closest('fieldset');

        fieldset?.querySelectorAll('input').forEach((sibling) => {
          sibling.classList.toggle('invalid', !isValid);
          sibling.classList.toggle('valid', isValid);
        })

        if(isValid) {
          fieldset?.querySelectorAll('.error-message').forEach((errorMessage) => {
            this.hideErrorMessage(errorMessage);
          })
        }
        
      } else {
        if(isValid) {
          const errorMessage = this.form.querySelector('.field-' + element.name +' .error-message');
          if(errorMessage instanceof HTMLElement) {
            this.hideErrorMessage(errorMessage);
          }
        }
      } 
      this.checkEmptiness(element);
    }
    return isValid;
  }

  protected async hideErrorMessage(errorMessage: Element): Promise<boolean>
  {
    errorMessage.classList.add('scale-out-ver-top');
    return new Promise(resolve => setTimeout(() => {
      errorMessage.remove();
      resolve(true);
    }, 500));
  }

  protected setLoading(isLoading: boolean = true): void
  {
    document.body.classList.toggle('is-loading', isLoading);
  }

  protected setDisabled(disable: boolean = true): void
  {
    this.form.querySelectorAll('section input, section select, section textarea, section button').forEach(el => {
      el.toggleAttribute('disabled', disable)
    })
  }
}